import { Component, OnDestroy, OnInit } from '@angular/core'
import { AuthService } from '../../../../services/auth.services'
import { RestServices } from '../../../../services/rest.services'
import { SharedServices } from '../../../../services/shared.services'
import { ActivatedRoute, ParamMap, Router } from '@angular/router'
import { ModalService } from '../../../../services/modal.service'
import * as moment from 'moment'
import { isUndefined, omitBy } from 'lodash'
import { MatrixServices } from '../../../../services/image/matrix.services'
import { StateServices } from '../../../../services/state.services'
import { AlignerHelper } from '../../../../../helper/aligner.helper'
import { Subscription } from 'rxjs/Subscription'

@Component({
    selector: 'app-aligner',
    templateUrl: './aligner.component.html',
    styleUrls: [
        '../../../../stagingcss/main-body.component.css',
        '../../../../stagingcss/root-ui-view.component.css',
        '../../../../stagingcss/ui-schema-table-form.component.css',
        './aligner.component.css',
        '../../../../stagingcss/lui-select.component.css',
    ],
})
export class AlignerComponent implements OnInit, OnDestroy {
    listAligner: any
    listClient
    str: any
    en = {}
    showEN = true
    idAligner
    activeAligner = false
    listStaff = []
    activeTitle = ''

    phaseNumber = AlignerHelper.PHASE_NUMBERS
    phaseByName = AlignerHelper.PHASE_BY_NAMES

    clientAlignerForm: any[] = []

    arrayAlignerTabs: any[] = []

    jsonDataSave: any = {}
    arrImage: any[] = []
    arrImageHash: any[]
    animationDuration: any = 2800

    arrIdClickedTabs: any[] = []

    enableBehavior: any = 'false'

    oldArrImageHash: any
    oldArrRotate: any
    oldArrStyleImage: any
    oldArrFlip: any
    oldDxdyMatrixCanvas: any
    oldArrImage: any

    resetValue
    private changeEmmitSubscription: Subscription
    totalNumber: any
    arrPassedDate: any[]
    countStageAligner: any = 0
    pageName: string = ''

    constructor(
        private modalService: ModalService,
        private authData: AuthService,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private restApi: RestServices,
        private _sharedService: SharedServices,
        public matrixServices: MatrixServices,
        private stateServices: StateServices,
    ) {
        this.pageName = this.stateServices.UseSearchPageList.ALIGNER_CLIENT_DETAIL.pageName
        this.changeEmmitSubscription = modalService.changeEmitted$.subscribe(
            success => {
                if (success.action === 'refreshAligner') {
                    this.listAligner = success.listAligner
                    if (
                        success.listClient &&
                        success.listClient.activeAligner != undefined
                    ) {
                        this.activeAligner = success.listClient.activeAligner
                        const activeAligner = this.listAligner.find(
                            x => x._id === this.activeAligner,
                        )
                        if (activeAligner) {
                            this.setActiveAligner(
                                this.activeAligner,
                                activeAligner,
                                true,
                            )
                        } else {
                            this.setActiveAligner(
                                this.activeAligner,
                                null,
                                false,
                            )
                        }
                    } else {
                        console.log(this.activeAligner, this.idAligner)
                        // this.setActiveAligner(this.activeAligner, null, false);
                    }
                } else if (success.action === 'removeAligner') {

                    this.setActiveAligner(this.activeAligner, null, false)
                }
            },
        )
    }

    ngOnInit() {
        this.stateServices.resetData()
        this.matrixServices.resetMatrix()
        this._sharedService.emitChange(null)
        this.stateServices.emitChangeTabName('formSetting')
        this.stateServices.emitChangeViewAligner('searchData')
        this.enableBehavior = this.stateServices.returnEnableBehavior()
        const emit: any = {}
        this.arrayAlignerTabs = [{ init: 'hidden' }]
        this.jsonDataSave = {}
        emit['status'] = 'hide'
        emit['view'] = 'aligner-create'
        this._sharedService.emitChangeIsShowConfirm(emit)
        this._sharedService.changeEmittedSource$.subscribe(success => {
            this.listAligner = success
        })
        this.activatedRoute.parent.paramMap.subscribe((params: ParamMap) => {
            const id = params.get('id')
            this.idAligner = id
        })
        this.getListAligner()
        this.resetValueMatrix()
        // this.searchAligner();
        // this.getArrHash();
    }

    ngOnDestroy() {
        if(this.resetValue)
            this.resetValue.unsubscribe()
        if(this.changeEmmitSubscription)
            this.changeEmmitSubscription.unsubscribe()
    }

    resetValueMatrix() {
        this.resetValue = this.stateServices.changeEmittedResetValueMatrix$.subscribe(
            res => {
                if (res) {
                    this.matrixServices.arrImageHash = this.oldArrImageHash
                    this.matrixServices.arrFlip = this.oldArrFlip
                    this.matrixServices.arrImage = this.oldArrImage
                    this.matrixServices.arrRotate = this.oldArrRotate
                    this.matrixServices.arrStyleImage = this.oldArrStyleImage
                    this.matrixServices.dXdYMatrixCanvas = this.oldDxdyMatrixCanvas
                    this.stateServices.emitChangeResetValueMatrix(null)
                }
            },
        )
    }

    functionEmitDataSearch(dataSearch: any) {
        const resourceUrl = 'resource'
        let strkeySearch = `{"clientId":"${ this.idAligner }"`
        const map = {}
        map[this.idAligner] = true
        const searches = {}
        const end = '}'

        this.arrIdClickedTabs = dataSearch['arrIdClickedTabs']
        this.jsonDataSave = dataSearch['jsonDataSearch']
        if (this.arrIdClickedTabs.length == 0) {
            strkeySearch = `{"clientId":"${ this.idAligner }"}`
        } else {
            this.arrIdClickedTabs.forEach(el => {
                if (this.jsonDataSave[el]) {
                    if (typeof this.jsonDataSave[el] == 'object') {
                        if (Array.isArray(this.jsonDataSave[el])) {
                            if (this.jsonDataSave[el].length > 0) {
                                let tmpContent = ''
                                this.jsonDataSave[el].forEach((item, i) => {
                                    if (i == 0) {
                                        tmpContent =
                                            '{"' +
                                            el +
                                            '": { "$all": ["' +
                                            item +
                                            '"]}}'
                                    } else {
                                        // tmpContent += `,"${item}"`;
                                        tmpContent +=
                                            ',{"' +
                                            el +
                                            '": { "$all": ["' +
                                            item +
                                            '"]}}'
                                    }
                                })
                                // strkeySearch += `,"${el}":[${tmpContent}]`;
                                strkeySearch +=
                                    ',"$and" : [ {"$or": [' +
                                    tmpContent +
                                    ']}]'
                            } else {
                                // strkeySearch += `,"${el}":null`;
                                strkeySearch +=
                                    ',"$and" : [ {"$or":[{"' +
                                    el +
                                    '":null}, { "' +
                                    el +
                                    '":[]}]} ]'
                            }
                        } else {
                            const contentKeys = JSON.stringify(
                                this.jsonDataSave[el],
                            )
                            strkeySearch += `,"${ el }":${ contentKeys }`
                        }
                    } else if (typeof this.jsonDataSave[el] == 'number') {
                        const searchDate = moment(this.jsonDataSave[el])
                        .utc()
                        .startOf('day')
                        .valueOf()
                        strkeySearch += `,"${ el }":${ searchDate }`
                    } else {
                        const tmpTrim = '' + this.jsonDataSave[el]
                        strkeySearch += `,"${ el }":{"_$regex":"${ tmpTrim.trim() }"}`
                    }
                } else {
                    // strkeySearch += `,"${el}":null`;
                    let obj = this.arrayAlignerTabs.find(
                        o => o.propertyName === el,
                    )
                    let typeinput = obj['schema']['type']
                    if (typeinput == 'array') {
                        strkeySearch +=
                            ',"$and" : [ {"$or":[{"' +
                            el +
                            '":null}, { "' +
                            el +
                            '":[]}]} ]'
                    } else {
                        strkeySearch += ',"' + el + '":null'
                    }
                }
            })
            strkeySearch += end
        }
        searches[strkeySearch] = true
        const resourceData = {
            actions: [],
            status: {
                client: {
                    map,
                },
                clientAligner: {
                    searches,
                },
                clinic: {
                    paths: {
                        '{}': true,
                    },
                },
                setting: {
                    map: {
                        common: true,
                    },
                    paths: {
                        '{}': true,
                    },
                },
                staff: {
                    paths: {
                        '{"roles":"cordinator"}': true,
                        '{"roles":"doctor"}': true,
                        '{}': true,
                    },
                },
            },
        }
        this.authData.authToken().then(tokenReNew => {
            this.restApi
            .http_post(resourceUrl, resourceData, tokenReNew)
            .subscribe(success => {
                this.listAligner =
                    success['response']['clientAligner']['searches'][
                        strkeySearch
                        ]
                this.listAligner.sort(function(a, b) {
                    return b['createTime'] - a['createTime']
                })
            })
        })
    }

    changeLanguage() {
        return (this.en = this.authData.showLang(this.showEN))
    }

    convertPhaseName(phase) {
        if (this.phaseByName[phase]) {
            return this.phaseByName[phase].name
        } else if (this.phaseNumber[phase - 1]) {
            return this.phaseNumber[phase - 1].name
        }
        return ''
    }

    updateActiveTitle() {
        if (this.listClient && this.listClient.alignerParam) {
            const phase = this.convertPhaseName(
                this.listClient.alignerParam['phase'],
            )
            const title = this.listClient.alignerParam['title'] || ''
            let fullTitle = phase + ' ' + title
            fullTitle = fullTitle.trim()
            if (phase || title) {
                this.activeTitle = '(' + fullTitle + ')'
            } else {
                this.activeTitle = ''
            }
        }
    }

    // list aligner
    getListAligner() {
        const resourceUrl = 'resource'
        const map = {}
        map[this.idAligner] = true
        const searches = {}
        searches['{"clientId":"' + this.idAligner + '"}'] = true
        const resourceData = {
            actions: [],
            status: {
                client: {
                    map,
                },
                clientAligner: {
                    searches,
                },
                clinic: {
                    paths: {
                        '{}': true,
                    },
                },
                setting: {
                    map: {
                        common: true,
                    },
                    paths: {
                        '{}': true,
                    },
                },
                staff: {
                    paths: {
                        '{"roles":"cordinator"}': true,
                        '{"roles":"doctor"}': true,
                        '{}': true,
                    },
                },
            },
        }
        this.authData.authToken().then(tokenReNew => {
            this.restApi
            .http_post(resourceUrl, resourceData, tokenReNew)
            .subscribe(success => {
                const user = success['user']
                this.enableBehavior = this.stateServices.checkEnableSettingBehaviour(
                    user['_id'],
                )
                const emitSakura = {}
                emitSakura['enableBehavior'] = this.enableBehavior
                this.stateServices.emitChangeEnableBehavior(emitSakura)
                this.listAligner =
                    success['response']['clientAligner']['searches'][
                    '{"clientId":"' + this.idAligner + '"}'
                        ]
                this.listAligner.sort(function(a, b) {
                    return b['createTime'] - a['createTime']
                })
                // console.log(this.listAligner);
                const arraySettingAll: any[] =
                    success['response']['setting']['paths']['{}']
                const arraySettingOption = arraySettingAll.find(el => {
                    return el['_id'] == 'option'
                })
                if (arraySettingOption) {
                    this.clientAlignerForm = arraySettingOption[
                        'clientAlignerForm'
                        ]
                        ? arraySettingOption['clientAlignerForm'][
                            'properties'
                            ]
                        : []
                } else {
                    this.clientAlignerForm = []
                }
                if (this.enableBehavior == 'true') {
                    this.arrayAlignerTabs = this.clientAlignerForm.filter(
                        el => {
                            return el['isCondition'] == true
                        },
                    )
                } else {
                    this.arrayAlignerTabs = []
                }
                this.listClient =
                    success['response']['client']['map'][this.idAligner]
                this.activeAligner = this.listClient.activeAligner
                this.listStaff =
                    success['response']['staff']['paths']['{}']
                this.updateActiveTitle()

                const emitListSetting: any = {}
                emitListSetting[
                    'listSettingAligner'
                    ] = this.arrayAlignerTabs
                this.stateServices.emitChangeListSettingTabs(
                    emitListSetting,
                )

                //count satge aligner
                this.checkActiveAligner()
            })
        })
    }

    checkActiveAligner(){
        if(this.activeAligner){
            let findActiveAlgner = this.listAligner.find(ele => {
                return ele._id == this.activeAligner;
            })
            //set list 'aligner' follow 'flows' for show number stage now if data conflict
            let aligners = AlignerHelper.computeStates(findActiveAlgner)
            this.countStageAligner = this.getActiveCount(aligners, findActiveAlgner.lastPassedAlignerCount)
            if(this.listClient.alignerParam && this.listClient.alignerParam.count) this.listClient.alignerParam.count = this.countStageAligner
        }
    }

    updateActiveAligner(dataUpdate) {
        const resourceUrl = 'resource'

        let strkeySearch = `{"clientId":"${ this.idAligner }"`
        const map = {}
        map[this.idAligner] = true
        const searches = {}
        const end = '}'

        if (this.arrIdClickedTabs.length === 0) {
            strkeySearch = `{"clientId":"${ this.idAligner }"}`
        } else {
            this.arrIdClickedTabs.forEach(el => {
                if (this.jsonDataSave[el]) {
                    if (typeof this.jsonDataSave[el] === 'object') {
                        if (Array.isArray(this.jsonDataSave[el])) {
                            if (this.jsonDataSave[el].length > 0) {
                                let tmpContent = ''
                                this.jsonDataSave[el].forEach((item, i) => {
                                    if (i === 0) {
                                        tmpContent = `"${ item }"`
                                    } else {
                                        tmpContent += `,"${ item }"`
                                    }
                                })
                                strkeySearch += `,"${ el }":[${ tmpContent }]`
                            } else {
                                strkeySearch += `,"${ el }":null`
                            }
                        } else {
                            const contentKeys = JSON.stringify(
                                this.jsonDataSave[el],
                            )
                            strkeySearch += `,"${ el }":${ contentKeys }`
                        }
                    } else if (typeof this.jsonDataSave[el] == 'number') {
                        const searchDate = moment(this.jsonDataSave[el])
                        .utc()
                        .startOf('day')
                        .valueOf()
                        strkeySearch += `,"${ el }":${ searchDate }`
                    } else {
                        const tmpTrim = '' + this.jsonDataSave[el]
                        strkeySearch += `,"${ el }":"${ tmpTrim.trim() }"`
                    }
                } else {
                    strkeySearch += `,"${ el }":null`
                }
            })
            strkeySearch += end
        }
        searches[strkeySearch] = true

        const resourceData = {
            actions: [
                {
                    collection: 'client',
                    id: this.idAligner,
                    type: 'update',
                    value: dataUpdate,
                },
            ],
            status: {
                client: {
                    map,
                },
                clientAligner: {
                    searches,
                },
                clinic: {
                    paths: {
                        '{}': true,
                    },
                },
                setting: {
                    map: {
                        common: true,
                    },
                    paths: {
                        '{}': true,
                    },
                },
                staff: {
                    paths: {
                        '{"roles":"cordinator"}': true,
                        '{"roles":"doctor"}': true,
                        '{}': true,
                    },
                },
            },
        }
        this.authData.authToken().then(tokenReNew => {
            this.restApi
            .http_post(resourceUrl, resourceData, tokenReNew)
            .subscribe(success => {
                this.listAligner =
                    success['response']['clientAligner']['searches'][
                        strkeySearch
                        ]
                this.listAligner.sort(function(a, b) {
                    return b['createTime'] - a['createTime']
                })
                this.listClient =
                    success['response']['client']['map'][this.idAligner]
                this.activeAligner = this.listClient.activeAligner
                this.updateActiveTitle()
            })
        })
        this.checkActiveAligner()
    }

    setActiveAligner(activeAligner, listAligner, statusActive) {
        if (this.activeAligner === activeAligner && statusActive === false) {
            this.activeAligner = null
            const dataClient = {
                activeAligner: null,
                alignerParam: null,
            }
            this.updateActiveAligner(dataClient)
        } else {
            this.activeAligner = activeAligner

            listAligner.aligners = AlignerHelper.computeStates(listAligner)
            this.authData.authToken().then(tokenReNew => {
                this.restApi
                .http_post(
                    'aligner/active-params',
                    { clientAligner: listAligner },
                    tokenReNew,
                )
                .subscribe((result: any) => {
                    if (result.success) {
                        const dataClient = {
                            activeAligner: activeAligner,
                            alignerParam: result.data,
                        }
                        this.updateActiveAligner(
                            omitBy(dataClient, isUndefined),
                        )
                    }
                })
            })
        }
    }

    getActiveCount(alignerList, lastPassedAlignerCount) {
        const currentDate = moment().utc().startOf('day').valueOf()
        let pos = -1
        if (alignerList.length > 0) {
            alignerList.forEach(function(item, index) {
                if (item.startDate && currentDate >= item.startDate) {
                    pos = index + 1
                }
            })
        }
        if (pos > lastPassedAlignerCount) {
            pos = lastPassedAlignerCount || -1
        }
        return pos
    }

    editAligner(_idAligner, totalNumber) {
        if (this.listAligner) {
            this.stateServices.emitChangeViewAligner('renderData')
            const activeAlignerInfo = this.listAligner.find(
                x => x._id === this.activeAligner,
            )
            const stageActive = totalNumber && totalNumber > 0 ? true : false
            this.oldArrImageHash = jQuery.extend(
                true,
                [],
                this.matrixServices.arrImageHash,
            )
            this.oldArrRotate = jQuery.extend(
                true,
                [],
                this.matrixServices.arrRotate,
            )
            this.oldArrStyleImage = jQuery.extend(
                true,
                [],
                this.matrixServices.arrStyleImage,
            )
            this.oldArrFlip = jQuery.extend(
                true,
                [],
                this.matrixServices.arrFlip,
            )
            this.oldDxdyMatrixCanvas = jQuery.extend(
                true,
                [],
                this.matrixServices.dXdYMatrixCanvas,
            )
            this.oldArrImage = jQuery.extend(
                true,
                [],
                this.matrixServices.arrImage,
            )
            this.matrixServices.resetMatrix()
            const arrAligner = {
                action: 'editAligner',
                clientId: this.idAligner,
                alignerId: _idAligner,
                clientDetail: this.listClient,
                activeAligner: activeAlignerInfo,
                stageActive: stageActive,
            }
            this._sharedService.emitChange(arrAligner)
        }
    }

    createAligner() {
        if (this.listAligner) {
            this.stateServices.emitChangeViewAligner('renderData')
            const activeAlignerInfo = this.listAligner.find(
                x => x._id === this.activeAligner,
            )
            this.oldArrImageHash = jQuery.extend(
                true,
                [],
                this.matrixServices.arrImageHash,
            )
            this.oldArrRotate = jQuery.extend(
                true,
                [],
                this.matrixServices.arrRotate,
            )
            this.oldArrStyleImage = jQuery.extend(
                true,
                [],
                this.matrixServices.arrStyleImage,
            )
            this.oldArrFlip = jQuery.extend(
                true,
                [],
                this.matrixServices.arrFlip,
            )
            this.oldDxdyMatrixCanvas = jQuery.extend(
                true,
                [],
                this.matrixServices.dXdYMatrixCanvas,
            )
            this.oldArrImage = jQuery.extend(
                true,
                [],
                this.matrixServices.arrImage,
            )
            this.matrixServices.resetMatrix()
            this._sharedService.emitChange({
                action: 'createAligner',
                clientId: this.idAligner,
                clientDetail: this.listClient,
                activeAligner: activeAlignerInfo,
                listStaff: this.listStaff,
            })
        }
    }

    computeStates(clientAligner) {
        const listFlows = clientAligner.flows
        clientAligner = this.initialEmptyStages(clientAligner)
        let listAligners = [].concat(clientAligner.aligners)
        this.totalNumber = clientAligner.totalNumber
        if (this.totalNumber === 0) {
            listAligners = []
        }
        // initial stage at flows
        if (listFlows.length > 0) {
            const distinctFlow = this.convertToDistinctArr(listFlows)
            const abortFrom = clientAligner['abortedFrom']
            const totalNumber = this.totalNumber
            const arrPassedDate = this.configPassedDateScreenStage(listFlows)
            distinctFlow.forEach(e => {
                if (e.nextCount <= totalNumber) {
                    if (abortFrom && e.nextCount > abortFrom) {
                        listAligners[e.nextCount - 1] = {}
                    } else if (abortFrom && e.nextCount === abortFrom) {
                        const aligner = {
                            doctor: e.doctor,
                            staff: e.staff,
                            updateDate: arrPassedDate[e.nextCount - 1],
                            abort: true,
                        }
                        listAligners[e.nextCount - 1] = omitBy(
                            aligner,
                            isUndefined,
                        )
                    } else {
                        const aligner = {
                            doctor: e.doctor,
                            elasticTypeLeft: e.elasticTypeLeft,
                            elasticTypeRight: e.elasticTypeRight,
                            interval: e.interval,
                            intervalUnit: e.intervalUnit,
                            staff: e.staff,
                            updateDate: arrPassedDate[e.nextCount - 1],
                            wearingTime: e.wearingTime,
                            buttoncut: e.buttoncut,
                            iprCount: e.iprCount,
                            precisioncut: e.precisioncut,
                            treatmentOptions: e.treatmentOptions,
                            changeDate: e.changeDate,
                            changeElasticTypeLeft: e.changeElasticTypeLeft,
                            changeElasticTypeRight: e.changeElasticTypeRight,
                            changeInterval: e.changeInterval,
                            changeUpdateDate: e.changeUpdateDate,
                            changeWearingTime: e.changeWearingTime,
                        }
                        if (e.nextStartDate) {
                            aligner['startDate'] = e.nextStartDate
                            const endDate = moment(aligner['startDate'])
                            .add(
                                aligner.wearingTime,
                                aligner.intervalUnit === 'days'
                                    ? 'days'
                                    : 'months',
                            )
                            .utc()
                            .startOf('day')
                            .valueOf()
                            aligner['endDate'] = endDate
                        }
                        listAligners[e.nextCount - 1] = omitBy(
                            aligner,
                            isUndefined,
                        )
                    }
                }
            })

            // create stage list
            const arrLength = this.totalNumber
            let i
            for (i = 0; i < arrLength; i++) {
                if (JSON.stringify(listAligners[i]) === '{}') {
                    const stage = {}
                    const preStage = listAligners[i - 1]
                    if (preStage['abort']) {
                        // if canceled stage
                        delete preStage['dateDiff']
                        delete preStage['changeDate']
                        stage['updateDate'] = arrPassedDate[i]
                        stage['abort'] = true
                        listAligners[i] = stage
                    } else {
                        stage['elasticTypeLeft'] = preStage.elasticTypeLeft
                        stage['elasticTypeRight'] = preStage.elasticTypeRight
                        stage['interval'] = preStage.interval
                        stage['intervalUnit'] = preStage.intervalUnit
                        stage['wearingTime'] = preStage.wearingTime
                        if (preStage.startDate) {
                            const startDate = moment(preStage.startDate)
                            .add(
                                preStage.interval,
                                preStage.intervalUnit === 'days'
                                    ? 'days'
                                    : 'months',
                            )
                            .utc()
                            .startOf('day')
                            .valueOf()
                            const endDate = moment(preStage.startDate)
                            .add(
                                preStage.wearingTime,
                                preStage.intervalUnit === 'days'
                                    ? 'days'
                                    : 'months',
                            )
                            .utc()
                            .startOf('day')
                            .valueOf()
                            stage['startDate'] = startDate
                            stage['endDate'] = endDate
                        }
                        stage['updateDate'] = arrPassedDate[i]
                        listAligners[i] = omitBy(stage, isUndefined)
                    }
                }
                // compute date diff
                if (
                    i > 0 &&
                    listAligners[i - 1] &&
                    listAligners[i - 1]['startDate'] &&
                    !listAligners[i]['abort']
                ) {
                    listAligners[i] = this.addDateDiff(
                        listAligners[i],
                        listAligners[i - 1],
                    )
                }
            }
        }
        return listAligners
    }

    initialEmptyStages(clientAligner) {
        let i
        const tmpArr = []
        const arrPassedDate = []
        for (i = 0; i < this.totalNumber; i++) {
            tmpArr.push({})
            arrPassedDate.push(null)
        }
        clientAligner.aligners = tmpArr
        this.arrPassedDate = arrPassedDate
        clientAligner.aligners[0] = {
            changeDate: true,
            changeElasticTypeLeft: true,
            changeElasticTypeRight: true,
            changeInterval: true,
            changeUpdateDate: true,
            changeWearingTime: true,
        }

        return clientAligner
    }

    convertToDistinctArr(flows: any) {
        const tmpFlows = [].concat(flows)
        const distinctFlow = []
        tmpFlows.forEach(item => {
            const found = tmpFlows.find(e => e.nextCount === item.nextCount)
            if (distinctFlow.indexOf(found) === -1) {
                distinctFlow.push(found)
            }
        })
        return distinctFlow
    }

    configPassedDateScreenStage(listFlows: any) {
        const arrPassedDate = this.arrPassedDate
        const totalNumber = this.totalNumber
        listFlows.forEach(e => {
            if (e.nextCount <= totalNumber && e.passedAligners > 0) {
                for (
                    let i = e.passedAlignerFrom - 1;
                    i <= e.passedAlignerTo - 1;
                    i++
                ) {
                    if (arrPassedDate[i] < e.updateDate) {
                        arrPassedDate.splice(i, 1, e.updateDate)
                    }
                }
            }
        })
        return arrPassedDate
    }

    addDateDiff(currentStage, beforeStage): any {
        const currentStageDate = moment(currentStage['startDate'])
        .utc()
        .startOf('day')
        .toDate()
        let beforeEndDate = currentStageDate
        if (beforeStage) {
            beforeEndDate = moment(beforeStage['startDate'])
            .add(
                beforeStage.interval,
                beforeStage.intervalUnit === 'days' ? 'days' : 'months',
            )
            .utc()
            .startOf('day')
            .toDate()
        }
        const dateDiff = Math.floor(
            (currentStageDate.getTime() - beforeEndDate.getTime()) / 86400000,
        )
        currentStage.dateDiff = dateDiff
        if (dateDiff !== 0) {
            currentStage.changeDate = true
        }
        return currentStage
    }
}



// WEBPACK FOOTER //
// ./src/app/app_manager/app_element/client-detail/aligner/aligner.component.ts